import { TIMEOUT_TIME, STAGE_DIRNAME, BASE_PATH_API_DEV, BASE_PATH_API } from 'constants/general';
import axios from 'axios';
import { decodeStorage } from 'functions/storageBase64';

export async function postEnviarOTP(token, data) {
    //post enviar otp -- usuarios sin telefono guardado
    let apiURL;
    
    if (STAGE_DIRNAME === 'dev') {
        apiURL = `${BASE_PATH_API_DEV.serviceOptim}/app/v1/sms-notification?token=${token}`;
    } else {
        apiURL = `${BASE_PATH_API}/app/v1/sms-notification?token=${token}`;
    }

    const raw = data;

    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json; charset=utf-8'
        },
        data: raw
    };

    return await axios(config)
        .then(res => {
            const {
                headers,
                status,
                data
            } = res
            return {
                'headers': headers,
                'statusCode': status,
                'data': data,
                'error': ''
            }
        })
        .catch(error => {
            return {
                'headers': '',
                'statusCode': error.request.status,
                'data': error.request.response,
                'error': error.response.data.msg
            }
        })
}


export async function getEnviarOTP(token, medio) {
    //get enviar otp -- usuarios con telefono guardado
    let apiURL;

    let nedioSend = medio === 'whatsapp' ? `&template=registry&canal=whatsapp` : ''

    if (STAGE_DIRNAME === 'dev') {
        apiURL = `${BASE_PATH_API_DEV.serviceOptim}/app/v1/sms-notification?token=${token}${nedioSend}`;
    } else {
        apiURL = `${BASE_PATH_API}/app/v1/sms-notification?token=${token}${nedioSend}`;
    }

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${token}`
        }
    };

    return await axios(config)
        .then(res => {
            const {
                headers,
                status,
                data
            } = res
            return {
                'headers': headers,
                'statusCode': status,
                'data': data,
                'error': ''
            }
        })
        .catch(error => {
            return (
                {
                    'headers': '',
                    'statusCode': error.request.status,
                    'data': error.request.response,
                    'error': error.response?.data.msg

                })
        })
}


export async function getTraerInfoUsuario(token) {
    //get traer informacion de usuario con credito claroshop
    let apiURL;
    const access_token = decodeStorage('access_token')

    if (STAGE_DIRNAME === 'dev') {
        apiURL = `${BASE_PATH_API_DEV.serviceOptim}/app/v1/claroshop-credit?token=${token}`;
    } else {
        apiURL = `${BASE_PATH_API}/app/v1/claroshop-credit?token=${token}`;
    }

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${access_token}`
        }
    };

    return await axios(config)
        .then(res => {
            const {
                headers,
                status,
                data
            } = res
            return {
                'headers': headers,
                'statusCode': status,
                'data': data,
                'error': ''
            }
        })
        .catch(error => {
            return (
                {
                    'headers': '',
                    'statusCode': error.request.status,
                    'data': error.request.response,
                    'error': error.response?.data.msg

                })
        })
}


export async function getEnviarRegistroOTP(otp_key, code_otp) {

        const token = decodeStorage('access_token')
        let apiURL;
    
        if (STAGE_DIRNAME === 'dev') {
            apiURL = `${BASE_PATH_API_DEV.otp}/sms-notifications/v1/phone?key=${otp_key}&code=${code_otp}`;
        } else {
            apiURL = `${BASE_PATH_API}/sms-notifications/v1/phone?key=${otp_key}&code=${code_otp}`;
        }
    
        const config = {
            method: 'get',
            url: apiURL,
            timeout: TIMEOUT_TIME,
            withCredentials: false,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': `Bearer ${token}`
            }
        };
    
        return await axios(config)
            .then(res => {
                const {
                    headers,
                    status,
                    data
                } = res
                return {
                    'headers': headers,
                    'statusCode': status,
                    'data': data,
                    'error': ''
                }
            })
            .catch(error => {
                return (
                    {
                        'headers': '',
                        'statusCode': error.request.status,
                        'data': error.request.response,
                        'error': error.response?.data.msg
    
                    })
            })
    }